import CourseChapter from 'src/model/CourseChapter';
import courseChapterDatabaseMap from 'src/resource/course/CourseChapterDatabaseMap';

export default class CourseChapterRetriever {
  // List course chapters with option to filter by courseId.
  static async listCourseChapter(courseId?: string): Promise<Array<CourseChapter>> {
    let courseChapters: Array<CourseChapter> = Array.from(courseChapterDatabaseMap.values());
    if (courseId !== undefined) {
      courseChapters = courseChapters.filter(
        (courseChapter) => courseChapter.courseId === courseId,
      );
    }
    return courseChapters;
  }
}
